<template>
  <div>
    <component :is="component" />
  </div>
</template>

<script>
export default {
  components: {
    VirtualCard: () =>
      import('@/components/v2/cards/layouts/NewVirtualCard.vue'),
    AddNewCard: () => import('@/components/v2/cards/layouts/SelectCardType.vue')
  },
  data () {
    return {
      activeComponent: 'add-new-card'
    }
  },
  computed: {
    componentIsVirtualCards () {
      return this.$store.state.appTour.cardsScreen === 'new-virtual-card'
    },
    component () {
      if (this.componentIsVirtualCards) {
        return 'virtual-card'
      }
      return 'add-new-card'
    }
  }
}
</script>

<style scoped></style>
